var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRealMadrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_386",
    x: 0,
    y: 0,
    width: 73,
    height: 73,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29027",
    "data-name": "Group 29027",
    transform: "translate(-3746 4899)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 3746, -4899)",
    filter: "url(#Ellipse_386)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_386-2",
    "data-name": "Ellipse 386",
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons8-real-madrid",
    transform: "translate(3761 -4884.103)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50661",
    "data-name": "Path 50661",
    d: "M18.7,22.083a6.842,6.842,0,0,0-3.555,3.91l.741.741L25.979,36.826a8.495,8.495,0,0,0,3.5-2.677c.321-.418-.111-1.134.13-1.608l-.443-.891-5.317-5.317Z",
    transform: "translate(-1.172 -4.552)",
    fill: "#2980b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50662",
    "data-name": "Path 50662",
    d: "M26.317,9.1A2.316,2.316,0,0,0,24,11.42c0,.037.009.072.011.109l.761-.109,3.608,1.031a2.28,2.28,0,0,0,.253-1.031A2.316,2.316,0,0,0,26.317,9.1Z",
    transform: "translate(-3.189 -1.595)",
    fill: "#e74c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50663",
    "data-name": "Path 50663",
    d: "M22.317,9.1a2.294,2.294,0,0,0-2.246,2.858l3.791-.541.751.215c.007-.072.022-.141.022-.215A2.316,2.316,0,0,0,22.317,9.1Z",
    transform: "translate(-2.278 -1.595)",
    fill: "#e74c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50664",
    "data-name": "Path 50664",
    d: "M15.167,12.691l2.188.729,2.283-.326a2.3,2.3,0,0,0-4.471-.4Zm14.971-.471a2.311,2.311,0,0,0-4.289,1.2c0,.039.009.075.012.114l2.3.659Z",
    transform: "translate(-1.177 -2.05)",
    fill: "#e74c3c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50665",
    "data-name": "Path 50665",
    d: "M26.355,5.192a1.846,1.846,0,0,0-.386.039,4.635,4.635,0,0,0-2.7-1.513V2.1H21.722V3.717a4.635,4.635,0,0,0-2.7,1.513,1.846,1.846,0,0,0-.386-.039A4.647,4.647,0,0,0,14,9.825a2.24,2.24,0,0,0,.548,1.444,3.293,3.293,0,0,0,1.035.78c.124.062.239.108.355.154a.782.782,0,0,0,.9.618.873.873,0,0,0,.3-.131,9.9,9.9,0,0,1,5.351-1.32,9.9,9.9,0,0,1,5.351,1.32.777.777,0,0,0,1.081-.185.857.857,0,0,0,.124-.3c.116-.046.232-.093.355-.154a3.293,3.293,0,0,0,1.035-.78,2.24,2.24,0,0,0,.548-1.444A4.647,4.647,0,0,0,26.355,5.192Zm-9.243,5.776a3.375,3.375,0,0,1-.834-.3,1.793,1.793,0,0,1-.556-.409.589.589,0,0,1-.178-.432A3.06,3.06,0,0,1,18.116,6.79a4.507,4.507,0,0,0-.255,1.49,4.636,4.636,0,0,0,.556,2.185A10.9,10.9,0,0,0,17.112,10.968ZM25,10.057a13.626,13.626,0,0,0-5,0,3,3,0,0,1-.587-1.776,3.089,3.089,0,1,1,6.178,0A3,3,0,0,1,25,10.057Zm4.27.2a1.793,1.793,0,0,1-.556.409,3.375,3.375,0,0,1-.834.3,10.9,10.9,0,0,0-1.305-.5,4.636,4.636,0,0,0,.556-2.185,4.506,4.506,0,0,0-.255-1.49,3.06,3.06,0,0,1,2.571,3.035A.589.589,0,0,1,29.266,10.257Z",
    transform: "translate(-0.911)",
    fill: "#f1c40f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50666",
    "data-name": "Path 50666",
    d: "M20.811,5.1h1.544v6.178H20.811Zm.772,9.959A10.039,10.039,0,1,1,11.544,25.1,10.05,10.05,0,0,1,21.583,15.062m0-1.544A11.583,11.583,0,1,0,33.166,25.1,11.591,11.591,0,0,0,21.583,13.518Z",
    transform: "translate(0 -0.683)",
    fill: "#f1c40f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50667",
    "data-name": "Path 50667",
    d: "M30.988,28.765a8.4,8.4,0,0,1-1.768,5.181l-1.1-1.1a6.931,6.931,0,0,0-1.544-9.7l-4.077,4.077-4.077-4.077a6.931,6.931,0,0,0-1.544,9.7l-1.1,1.1a8.48,8.48,0,0,1,1.544-11.907,8.316,8.316,0,0,1,1.336-.849l3.072,3.072.774-.13h.9L26.34,21.19a8.316,8.316,0,0,1,1.336.849A8.454,8.454,0,0,1,30.988,28.765Z",
    transform: "translate(-0.911 -4.348)",
    fill: "#f1c40f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50668",
    "data-name": "Path 50668",
    d: "M26.695,31.421l1.22.973a5.405,5.405,0,1,1,0-5.977l-1.22.973a3.861,3.861,0,1,0,0,4.031Z",
    transform: "translate(-1.822 -4.988)",
    fill: "#f1c40f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50669",
    "data-name": "Path 50669",
    d: "M23.544,37.722H22V30h3.861v1.544H23.544Z",
    transform: "translate(-2.734 -6.355)",
    fill: "#f1c40f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50670",
    "data-name": "Path 50670",
    d: "M23,33h3.089v1.544H23Z",
    transform: "translate(-2.961 -7.039)",
    fill: "#f1c40f"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRealMadrid);
export default __webpack_public_path__ + "static/media/realMadrid.7102af95fda7c6513be2b6130f64f7b3.svg";
export { ForwardRef as ReactComponent };